import React, { useContext } from 'react';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faSpinner } from '@fortawesome/free-solid-svg-icons';

const ReportHeader = ({ onExportPdf, isExporting, isLoading, totalRegistros }) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
      <div>
        <h4 className="fw-bold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
          Crear Reporte de Tickets
        </h4>
        <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>
          Consulta histórica, filtrado por fechas y estados, y exportación ejecutiva en PDF.
        </p>
      </div>
      <div>
        <button
          type="button"
          className="btn btn-sm btn-danger d-flex align-items-center gap-2 px-3 py-2 shadow-none"
          onClick={onExportPdf}
          disabled={isExporting || isLoading || totalRegistros === 0}
          style={{ borderRadius: '8px' }}
        >
          <FontAwesomeIcon icon={isExporting ? faSpinner : faFilePdf} spin={isExporting} />
          <span>{isExporting ? 'Generando PDF...' : 'Exportar PDF'}</span>
        </button>
      </div>
    </div>
  );
};

export default ReportHeader;
